import { handleError } from './utils';

export const validateVoucher = (voucher) => handleError(async (dispatch, getState, { api }) => {
  const response = await api.validateVoucher(voucher);
  return response;
}, 'There was a problem when trying to validate the Voucher. Please try again later.');
